import { render, staticRenderFns } from "./CodesCSV.vue?vue&type=template&id=1f310bc0&scoped=true"
import script from "./CodesCSV.vue?vue&type=script&lang=js"
export * from "./CodesCSV.vue?vue&type=script&lang=js"
import style0 from "./CodesCSV.vue?vue&type=style&index=0&id=1f310bc0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f310bc0",
  null
  
)

export default component.exports